export default "__VITE_ASSET__Bt80MB7p__"